import { withInstall } from '../../../utils/with-install'
import ZMarkerLayer from './ZMarkerLayer.vue'

export const ElAmapLocaZMarker = withInstall(ZMarkerLayer)
export default ElAmapLocaZMarker
